import { type SearchableField } from '@framework/ui/components/search/ISearchableField.tsx';
import { useMemo } from 'react';
import { getCommonDossierSearchableField } from './getCommonDossierSearchableField.tsx';

export function useDossierSearchableFields(options: {
  extraFields?: SearchableField[];
  showAssignedUserFilter?: boolean;
  showPhaseFilter?: boolean;
}) {
  const result = useMemo(() => {
    const searchable = getCommonDossierSearchableField();
    return [...searchable, ...(options.extraFields ?? [])].sort((a, b) =>
      a.label > b.label ? 1 : -1,
    );
  }, [options.extraFields]);

  return result;
}
